<div class="setting-tab-container">
  <ng-template settingsHost></ng-template>
</div>
